var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 635,
    viewBox: "0 0 1440 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1260_110950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.088 342.687C1072.32 391.838 1469.46 396.546 1469.46 396.546L1469.46 262.025L810.088 342.687Z",
    fill: "url(#paint0_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1469.46 634.076L-51.8237 634.076L-51.8238 92.0377L1469.46 92.0376L1469.46 634.076Z",
    fill: "url(#paint1_radial_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1469.46 634.076L-51.8237 634.076L-51.8238 92.0377L1469.46 92.0376L1469.46 634.076Z",
    fill: "url(#paint2_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5757 377.212C274.297 364.72 497.365 444.002 790.271 450.718C1083.18 457.435 1364.83 382.673 1470.18 382.673L1470.18 299.939L68.3514 316.135L26.5757 377.212Z",
    fill: "url(#paint3_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.237 329.694C454.4 327.685 110.761 425.233 -51.8234 425.233L-51.8234 259.389L698.237 329.694Z",
    fill: "url(#paint4_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.8237 320.655L-51.8238 92.0379L1469.46 92.0378L1469.46 343.064C1290.39 321.157 1118.29 364.846 810.484 381.795C595.185 393.659 404.538 363.34 207.867 341.055C206.995 340.93 206.203 340.867 205.331 340.742C176.556 337.477 147.622 334.402 118.529 331.64C112.98 331.137 107.511 330.635 101.962 330.133C97.2054 329.694 92.3699 329.254 87.6136 328.878C83.8879 328.564 80.0829 328.25 76.3572 327.936C34.2643 324.546 -8.38331 321.91 -51.8237 320.655Z",
    fill: "url(#paint5_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.08 92.0379C543.501 109.3 858.285 172.7 1134.78 172.7C1235.38 172.7 1364.51 133.656 1470.18 137.61L1470.18 92.0378L150.08 92.0379Z",
    fill: "url(#paint6_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M150.08 92.0379C543.501 109.3 858.285 172.7 1134.78 172.7C1235.38 172.7 1364.51 133.656 1470.18 137.61L1470.18 92.0378L150.08 92.0379Z",
    fill: "url(#paint7_radial_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.18 92.0376L-51.8232 92.0377L-51.8233 0.0763431L1470.18 0.07621L1470.18 92.0376Z",
    fill: "#D1E3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.18 132.4L-51.8232 132.4L-51.8232 92.1002L1470.18 92.1001L1470.18 132.4Z",
    fill: "url(#paint8_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1260_110950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.242 349.192C1082.14 411.614 1475.75 417.593 1475.75 417.593L1475.75 246.751L822.242 349.192Z",
    fill: "url(#paint9_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1475.75 719.256L-32.0002 719.256L-32.0003 30.8672L1475.75 30.8671L1475.75 719.256Z",
    fill: "url(#paint10_radial_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.75 719.256L-32.0002 719.256L-32.0003 30.8672L1475.75 30.8671L1475.75 719.256Z",
    fill: "url(#paint11_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.701 393.039C291.218 377.174 512.301 477.862 802.601 486.392C1092.9 494.922 1372.04 399.974 1476.46 399.974L1476.46 294.902L87.105 315.47L45.701 393.039Z",
    fill: "url(#paint12_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761 390.458C503.204 387.733 139.892 520.076 -32 520.076L-32 295.076L761 390.458Z",
    fill: "url(#paint13_linear_1260_110950)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.0003 321.21L-32.0003 30.8672L1475.75 30.867L1475.75 349.67C1298.27 321.848 1127.7 377.334 822.635 398.858C609.251 413.925 420.301 375.42 225.38 347.12C224.516 346.96 223.73 346.88 222.866 346.721C194.347 342.575 165.671 338.669 136.837 335.161C131.338 334.524 125.916 333.886 120.417 333.248C115.703 332.69 110.91 332.132 106.197 331.654C102.504 331.255 98.7328 330.856 95.0402 330.458C53.3219 326.153 11.0537 322.805 -32.0003 321.21Z",
    fill: "url(#paint14_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.106 30.867C558.026 52.7902 870.01 133.308 1144.05 133.308C1243.75 133.308 1371.73 83.7218 1476.46 88.7442L1476.46 30.8669L168.106 30.867Z",
    fill: "url(#paint15_linear_1260_110950)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M168.106 30.867C558.026 52.7902 870.01 133.308 1144.05 133.308C1243.75 133.308 1371.73 83.7218 1476.46 88.7442L1476.46 30.8669L168.106 30.867Z",
    fill: "url(#paint16_radial_1260_110950)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1476.46 30.8672L-32.0002 30.8673L-32.0003 -85.9236L1476.46 -85.9238L1476.46 30.8672Z",
    fill: "#F4F9FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1260_110950",
    x1: 1201.21,
    y1: 415.867,
    x2: 1086.16,
    y2: 76.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1260_110950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(989.226 487.385) rotate(180) scale(1226.76 704.291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1260_110950",
    x1: 727.76,
    y1: 317.12,
    x2: 629.513,
    y2: 697.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1260_110950",
    x1: 770.892,
    y1: 457.09,
    x2: 726.427,
    y2: 83.8397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1260_110950",
    x1: 333.308,
    y1: 428.57,
    x2: 301.043,
    y2: 168.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1260_110950",
    x1: 905.137,
    y1: 557.843,
    x2: 684.953,
    y2: -70.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1260_110950",
    x1: 941.791,
    y1: 467.887,
    x2: 843.194,
    y2: 19.0331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1260_110950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1183.64 163.842) rotate(173.634) scale(247.844 62.2117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1260_110950",
    x1: 709.177,
    y1: 94.2413,
    x2: 709.177,
    y2: 130.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1260_110950",
    x1: 1209.88,
    y1: 442.131,
    x2: 1034.3,
    y2: 38.3677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1260_110950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(999.785 541.614) rotate(180) scale(1215.85 900.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1260_110950",
    x1: 720.516,
    y1: 94.5561,
    x2: 722.959,
    y2: 583.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1260_110950",
    x1: 783.392,
    y1: 494.483,
    x2: 711.678,
    y2: 24.6779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1260_110950",
    x1: 375.177,
    y1: 524.607,
    x2: 319.55,
    y2: 174.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBD9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1260_110950",
    x1: 916.442,
    y1: 622.443,
    x2: 581.607,
    y2: -123.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1260_110950",
    x1: 952.771,
    y1: 508.195,
    x2: 796.921,
    y2: -45.4894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1260_110950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1190.08 104.862) rotate(171.864) scale(246.61 77.5284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1260_110950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1522,
    height: 634,
    fill: "white",
    transform: "translate(1470.18 634.076) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1260_110950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1508.46,
    height: 805.18,
    fill: "white",
    transform: "translate(1476.46 719.256) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.3e326a383c2a88ec46ff907ecd5797c7.svg";
export { ForwardRef as ReactComponent };